import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-4 -mb-4" }
const _hoisted_2 = { class: "col-span-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "absolute top-0 right-5" }

import UnavailabilityForm from './UnavailabilityForm.vue'

	import {
		Notification
	} from '@/types'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore as _localesStore
	} from '@/store/locales'

	import {
		modifyUnavailability
	} from  '../mutations'

	import { // vue
		ref
	} from 'vue'
	
	
	const __default__ = { name: 'UnavailabilityDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  emits: ['refreshAccountData'],
  setup(__props, { emit: __emit }) {

	const props = __props



	const localesStore = _localesStore()

	const {t} = useI18n()

	const unavailabilityModal = ref<{open: boolean}>({open: false})

	const selectedRow = ref<{}>({})

	const emit = __emit

	function openUnavailabilityModal(row: Object) {
		selectedRow.value = row
		unavailabilityModal.value.open = true
	}

	const showNotification = ref(false)
	const notificationIcon = ref(0)
	const notificationTitle = ref('')
	const notificationSubtitle = ref('')
	
	function displayNotification(notification: Notification) {
		selectedRow.value = {}

		notificationIcon.value = notification.icon
		notificationTitle.value = notification.title
		notificationSubtitle.value = notification.subtitle
		unavailabilityModal.value.open = false
		showNotification.value = true
		emit('refreshAccountData')
	}
	
	async function deleteUnavailability(recordID: string) {
		const data = JSON.stringify({
			action: "delete",
			unavailabilityID: recordID,
		})

		try{
			const result = await modifyUnavailability(data)

			const scriptResult = JSON.parse(result.response.scriptResult)

			const fmpError = scriptResult.errorCode !== 0

			if (fmpError) {
				throw new Error(scriptResult.errorMessage)
			}

			const notification: Notification = {
				title: t('placeholders.success'),
				subtitle: t('account.unavailabilityDeleted'),
				icon: 0
			}

			displayNotification(notification)

		} catch (e) {
			const notification: Notification = {
				title: t('placeholders.error'),
				subtitle: t('placeholders.deleteUnavailabilityFail'),
				icon: 1
			}

			displayNotification(notification)
			console.error(e)
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_notification = _resolveComponent("tw-notification")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showNotification.value)
      ? (_openBlock(), _createBlock(_component_tw_notification, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showNotification.value = false)),
          title: notificationTitle.value,
          subtitle: notificationSubtitle.value,
          duration: 8000,
          icon: notificationIcon.value
        }, null, 8, ["title", "subtitle", "icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_tw_table, {
        placeholder: _unref(t)('placeholders.noUnavailability'),
        data: props?.contact?.portalData?.portal_unavailability,
        loading: __props.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: _unref(localesStore).getLabel('361')
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(row['contacts__DAYSOFF__contactID::date']), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(localesStore).getLabel('678')
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(row['contacts__DAYSOFF__contactID::availability_display']), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(localesStore).getLabel('737')
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(_unref(localesStore).getLabel(row['contacts__DAYSOFF__contactID::day_code'])), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(localesStore).getLabel('332')
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(`${_ctx.$filters.convertTime(row['contacts__DAYSOFF__contactID::time_start'])} - ${_ctx.$filters.convertTime(row['contacts__DAYSOFF__contactID::time_end'])}`), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_tw_table_column, null, {
            default: _withCtx(({row}) => [
              _createElementVNode("button", {
                class: "link",
                onClick: () => { openUnavailabilityModal(row) }
              }, _toDisplayString(_unref(localesStore).getLabel('702')), 9, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_tw_table_column, null, {
            default: _withCtx(({row}) => [
              _createElementVNode("button", {
                class: "link",
                onClick: () => { deleteUnavailability(row['contacts__DAYSOFF__contactID::_kp_daysoff_id']) }
              }, _toDisplayString("Delete"), 8, _hoisted_4)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["placeholder", "data", "loading"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openUnavailabilityModal({})))
        }, _toDisplayString(`${_unref(t)('account.submitUnavailability')}...`), 1)
      ]),
      _createVNode(_component_tw_modal, {
        title: Object.keys(selectedRow.value).length === 0 ? _unref(t)('account.submitUnavailability') : _unref(t)('account.editUnavailability'),
        breadcrumb: [],
        "modal-max-width": "max-w-md",
        "modal-min-height": "min-h-0",
        ref_key: "unavailabilityModal",
        ref: unavailabilityModal
      }, {
        default: _withCtx(() => [
          _createVNode(UnavailabilityForm, {
            contact: __props.contact,
            data: {...selectedRow.value},
            onCloseUnavailabilityModal: _cache[2] || (_cache[2] = (notification) => {displayNotification(notification)})
          }, null, 8, ["contact", "data"])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}
}

})